import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    title: "Payal One",
    author: "Pritam Kumar",
    currentPrice: 3999,
    categoryName: "Payal",
    image: "https://res.cloudinary.com/dhqxln7zi/image/upload/v1647168585/payal1_kkkhac.jpg",
    description: "Put your best foot forward pick your Indian bridal anklet from stunning bridal payal designs for your big day from our editors pick of bridal jewellery",
    rating: 4,
    inStock: 0,
    karat: 950,
    originalPrice: 10000,
    featured: true
  },
  {
    _id: uuid(),
    title: "Payal Two",
    author: "Pritam Kumar",
    currentPrice: 4000,
    categoryName: "Payal",
    image: "https://res.cloudinary.com/dhqxln7zi/image/upload/v1647168585/payal5_jymczh.jpg",
    description: "Put your best foot forward pick your Indian bridal anklet from stunning bridal payal designs for your big day from our editors pick of bridal jewellery",
    rating: 4,
    inStock: 3,
    karat: 950,
    originalPrice: 5500,
  },
  {
    _id: uuid(),
    title: "Payal Three",
    author: "Pritam Kumar",
    currentPrice: 9000,
    categoryName: "Payal",
    image: "https://res.cloudinary.com/dhqxln7zi/image/upload/v1647168585/payal3_pr8t83.jpg",
    description: "Put your best foot forward pick your Indian bridal anklet from stunning bridal payal designs for your big day from our editors pick of bridal jewellery",
    rating: 4,
    inStock: 15,
    karat: 950,
    originalPrice: 10502,
  },
  {
    _id: uuid(),
    title: "Payal Four",
    author: "Pritam Kumar",
    currentPrice: 4000,
    categoryName: "Payal",
    image: "https://res.cloudinary.com/dhqxln7zi/image/upload/v1647168585/payal4_ulbgaq.jpg",
    description: "Put your best foot forward pick your Indian bridal anklet from stunning bridal payal designs for your big day from our editors pick of bridal jewellery",
    rating: 4,
    inStock: 12,
    karat: 950,
    originalPrice: 5000,
    featured: true
  },
  {
    _id: uuid(),
    title: "Payal Five",
    author: "Pritam Kumar",
    currentPrice: 5600,
    categoryName: "Payal",
    image: "https://res.cloudinary.com/dhqxln7zi/image/upload/v1647168585/payal2_tcb3aq.jpg",
    description: "Put your best foot forward pick your Indian bridal anklet from stunning bridal payal designs for your big day from our editors pick of bridal jewellery",
    rating: 4,
    inStock: 0,
    karat: 950,
    originalPrice: 6000,
  },
  {
    _id: uuid(),
    title: "Ring One",
    author: "Pritam Kumar",
    currentPrice: 2000,
    categoryName: "Ring",
    image: "https://res.cloudinary.com/dhqxln7zi/image/upload/v1647168586/ring1_jw683f.png",
    description: "PLATINUM COUPLE RINGS BY JEWELOVEPGI Design Code : 19PTLBJ 9-10Tough on the surface. But Below it, that tender heart! When your eyes met, there was no telling you both apart - doubled in spirit, penning greater lines. Twinning and winning in a love that combines.Your story, brought alive in these textured Platinum Love Bands.Designer Platinum Love Bands with a touch of Rose Gold.Metal",
    rating: 3,
    inStock: 10,
    karat: 950,
    originalPrice: 3000,
    featured: true
  },
  {
    _id: uuid(),
    title: "Ring Two",
    author: "Pritam Kumar",
    currentPrice: 6000,
    categoryName: "Ring",
    image: "https://res.cloudinary.com/dhqxln7zi/image/upload/v1647168586/ring2_oydetp.png",
    description: "PLATINUM COUPLE RINGS BY JEWELOVEPGI Design Code : 19PTLBJ 9-10Tough on the surface. But Below it, that tender heart! When your eyes met, there was no telling you both apart - doubled in spirit, penning greater lines. Twinning and winning in a love that combines.Your story, brought alive in these textured Platinum Love Bands.Designer Platinum Love Bands with a touch of Rose Gold.Metal",
    rating: 3,
    inStock: 10,
    karat: 950,
    originalPrice: 7000,
    featured: true
  },
  {
    _id: uuid(),
    title: "Ring Three",
    author: "Pritam Kumar",
    currentPrice: 4000,
    categoryName: "Ring",
    image: "https://res.cloudinary.com/dhqxln7zi/image/upload/v1647168586/ring3_xetzsm.png",
    description: "PLATINUM COUPLE RINGS BY JEWELOVEPGI Design Code : 19PTLBJ 9-10Tough on the surface. But Below it, that tender heart! When your eyes met, there was no telling you both apart - doubled in spirit, penning greater lines. Twinning and winning in a love that combines.Your story, brought alive in these textured Platinum Love Bands.Designer Platinum Love Bands with a touch of Rose Gold.Metal",
    rating: 3,
    inStock: 10,
    karat: 950,
    originalPrice: 5000,
    featured: true
  },
  {
    _id: uuid(),
    title: "Ring Four",
    author: "Pritam Kumar",
    currentPrice: 5700,
    categoryName: "Ring",
    image: "https://res.cloudinary.com/dhqxln7zi/image/upload/v1647168586/ring4_v0mzoq.png",
    description: "PLATINUM COUPLE RINGS BY JEWELOVEPGI Design Code : 19PTLBJ 9-10Tough on the surface. But Below it, that tender heart! When your eyes met, there was no telling you both apart - doubled in spirit, penning greater lines. Twinning and winning in a love that combines.Your story, brought alive in these textured Platinum Love Bands.Designer Platinum Love Bands with a touch of Rose Gold.Metal",
    rating: 3,
    inStock: 10,
    karat: 950,
    originalPrice: 70000,
  },
  {
    _id: uuid(),
    title: "Ring Five",
    author: "Pritam Kumar",
    currentPrice: 5900,
    categoryName: "Ring",
    image: "https://res.cloudinary.com/dhqxln7zi/image/upload/v1647168586/ring5_xyo4wh.png",
    description: "PLATINUM COUPLE RINGS BY JEWELOVEPGI Design Code : 19PTLBJ 9-10Tough on the surface. But Below it, that tender heart! When your eyes met, there was no telling you both apart - doubled in spirit, penning greater lines. Twinning and winning in a love that combines.Your story, brought alive in these textured Platinum Love Bands.Designer Platinum Love Bands with a touch of Rose Gold.Metal",
    rating: 2,
    inStock: 0,
    karat: 950,
    originalPrice: 6999,
    featured: true
  },
  {
    _id: uuid(),
    title: "Ear Ring One",
    author: "Pritam Kumar",
    currentPrice: 5000,
    categoryName: "Ear Ring",
    image: "https://res.cloudinary.com/dhqxln7zi/image/upload/v1647168583/earring1_h43srb.png",
    description: "Exploring diamond jewellery in India? Get exquisite diamond jewellery designs at Hazoorilal Jewellers, the trusted jewellers in Delhi",
    rating: 2,
    inStock: 10,
    karat: 950,
    originalPrice: 7852,
    featured: true
  },
  {
    _id: uuid(),
    title: "Ear Ring Two",
    author: "Pritam Kumar",
    currentPrice: 6452,
    categoryName: "Ear Ring",
    image: "https://res.cloudinary.com/dhqxln7zi/image/upload/v1647168583/earring2_gqjcbq.png",
    description: "Exploring diamond jewellery in India? Get exquisite diamond jewellery designs at Hazoorilal Jewellers, the trusted jewellers in Delhi",
    rating: 2,
    inStock: 10,
    karat: 950,
    originalPrice: 11960,
  },
  {
    _id: uuid(),
    title: "Ear Ring Three",
    author: "Pritam Kumar",
    currentPrice: 5000,
    categoryName: "Ear Ring",
    image: "https://res.cloudinary.com/dhqxln7zi/image/upload/v1647168583/earring3_fyjmgr.png",
    description: "Exploring diamond jewellery in India? Get exquisite diamond jewellery designs at Hazoorilal Jewellers, the trusted jewellers in Delhi",
    rating: 2,
    inStock: 10,
    karat: 950,
    originalPrice: 7000,
  },
  {
    _id: uuid(),
    title: "Ear Ring Four",
    author: "Pritam Kumar",
  currentPrice: 6879,
    categoryName: "Ear Ring",
    image: "https://res.cloudinary.com/dhqxln7zi/image/upload/v1647168583/earring4_qjfski.png",
    description: "Exploring diamond jewellery in India? Get exquisite diamond jewellery designs at Hazoorilal Jewellers, the trusted jewellers in Delhi",
    rating: 2,
    inStock: 10,
    karat: 950,
    originalPrice: 9000,
  },
  {
    _id: uuid(),
    title: "Ear Ring Five",
    author: "Pritam Kumar",
    currentPrice: 4800,
    categoryName: "Ear Ring",
    image: "https://res.cloudinary.com/dhqxln7zi/image/upload/v1647168583/earring5_g2vwle.png",
    description: "Exploring diamond jewellery in India? Get exquisite diamond jewellery designs at Hazoorilal Jewellers, the trusted jewellers in Delhi",
    rating: 1,
    inStock: 10,
    karat: 950,
    originalPrice: 5800,
  },
  {
    _id: uuid(),
    title: "Necklace One",
    author: "Pritam Kumar",
    currentPrice: 3400,
    categoryName: "Necklace",
    image: "https://res.cloudinary.com/dhqxln7zi/image/upload/v1647168584/necklace1_nv0gxu.png",
    description: "Platinum Evara brings you beautifully crafted colllection of platinum necklace sets to complement with the platinum earrings. Browse platinum necklace designs today!",
    rating: 1,
    inStock: 10,
    karat: 950,
    originalPrice: 3500,
  },
  {
    _id: uuid(),
    title: "Necklace Two",
    author: "Pritam Kumar",
    currentPrice: 2000,
    categoryName: "Necklace",
    image: "https://res.cloudinary.com/dhqxln7zi/image/upload/v1647168585/necklace2_aups97.png",
    description: "Platinum Evara brings you beautifully crafted colllection of platinum necklace sets to complement with the platinum earrings. Browse platinum necklace designs today!",
    rating: 1,
    inStock: 10,
    karat: 950,
    originalPrice: 2200,
    featured: true
  },
  {
    _id: uuid(),
    title: "Necklace Three",
    author: "Pritam Kumar",
    currentPrice: 7000,
    categoryName: "Necklace",
    image: "https://res.cloudinary.com/dhqxln7zi/image/upload/v1647168584/necklace3_taj2zs.png",
    description: "Platinum Evara brings you beautifully crafted colllection of platinum necklace sets to complement with the platinum earrings. Browse platinum necklace designs today!",
    rating: 1,
    inStock: 10,
    karat: 950,
    originalPrice: 7500,
  },
  {
    _id: uuid(),
    title: "Necklace Four",
    author: "Pritam Kumar",
    currentPrice: 9600,
    categoryName: "Necklace",
    image: "https://res.cloudinary.com/dhqxln7zi/image/upload/v1647168584/necklace4_gsxaxb.png",
    description: "Platinum Evara brings you beautifully crafted colllection of platinum necklace sets to complement with the platinum earrings. Browse platinum necklace designs today!",
    rating: 3,
    inStock: 10,
    karat: 950,
    originalPrice: 10000,
  },
  {
    _id: uuid(),
    title: "Necklace Five",
    author: "Pritam Kumar",
    currentPrice: 8900,
    categoryName: "Necklace",
    image: "https://res.cloudinary.com/dhqxln7zi/image/upload/v1647168584/necklace5_s6kth4.png",
    description: "Platinum Evara brings you beautifully crafted colllection of platinum necklace sets to complement with the platinum earrings. Browse platinum necklace designs today!",
    rating: 2,
    inStock: 10,
    karat: 950,
    originalPrice: 9500,
  }
];
